import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from '../../../data.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'sr-listing-filter-dialog',
    templateUrl: 'sr-listing-filter-dialog.html',
    styleUrls: ['sr-listing-filter-dialog.scss']
})
export class SRListingFilterDialog implements OnInit {

    myForm:FormGroup;
    filter = {
        requestStatus: [],
        orderBy: "",
    };

    constructor(
        public dialogRef: MatDialogRef<SRListingFilterDialog>,
        public dataService: DataService,

        @Inject(MAT_DIALOG_DATA) private data,

    ) {
        if(data){
            
        }
    }

    ngOnInit() {
        let orderby="desc";
        if(this.dataService.filter.orderBy){
            orderby = this.dataService.filter.orderBy
        }
        this.myForm = new FormGroup({
            orderBy: new FormControl(orderby),
            requestStatus: new FormControl(this.dataService.filter.requestStatus)
        });
    }
    
    reset() {
        this.myForm.get("requestStatus").setValue(["Open","In Progress"]);
        this.myForm.get("orderBy").setValue("desc");
    }

    onSubmit() {
        this.filter = this.myForm.value;
        // if ((this.filter.requestStatus.length == 0) && (this.dataService.filterHistory.requestStatus.length > 0)) {
        //     this.filter.requestStatus = this.dataService.filterHistory.requestStatus;
        // }
        if (this.filter.requestStatus.length == 0) {
            this.filter.requestStatus = ["Open","In Progress","Resolved","Closed"]
        }
        
        this.dataService.filter.requestStatus = this.filter.requestStatus;
        this.dataService.filter.orderBy = this.filter.orderBy;
        this.dialogRef.close( this.dataService.filter);
    }
}
